// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"93":"Character","268":"Home"}[chunkId] + "." + {"93":"1a27395c","268":"b3808c20"}[chunkId] + ".js";
};